import { alpha, Button, MenuItem, styled } from "@mui/material";
import { useEffect, useState } from "react";
import Menu, { MenuProps } from "@mui/material/Menu";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import BackupIcon from "@mui/icons-material/Backup";
import { PostFollowModel } from "../models/PostFollowModel";
import { useNavigate } from "react-router-dom";

export default function DropDownMenu({ uuid, isFollowed = null }) {
  const [action, setAction] = useState<string>("follow");
  const [starIcon, setStarIcon] = useState<any>(<StarIcon />);
  const [anchorEl, setAnchorEl] = useState<any | null>(null);

  const open = Boolean(anchorEl);

  const navigate = useNavigate();

  useEffect(() => {
    if (isFollowed !== null && isFollowed === true) {
      // se il contenuto è seguito dall'utente corrente, allora l'azione sarà di unfollow
      setAction("unfollow");
      setStarIcon(<StarBorderIcon />);
    }
  }, [isFollowed]);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const StyledMenu = styled((props: MenuProps) => (
    <Menu
      elevation={0}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      {...props}
    />
  ))(({ theme }) => ({
    "& .MuiPaper-root": {
      borderRadius: 6,
      marginTop: theme.spacing(1),
      minWidth: 180,
      color:
        theme.palette.mode === "light"
          ? "rgb(55, 65, 81)"
          : theme.palette.grey[300],
      boxShadow:
        "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
      "& .MuiMenu-list": {
        padding: "4px 0",
      },
      "& .MuiMenuItem-root": {
        "& .MuiSvgIcon-root": {
          fontSize: 18,
          color: theme.palette.text.secondary,
          marginRight: theme.spacing(1.5),
        },
        "&:active": {
          backgroundColor: alpha(
            theme.palette.primary.main,
            theme.palette.action.selectedOpacity,
          ),
        },
      },
    },
  }));

  function follow() {
    let response = null;

    console.log("Starting API call PostFollowModel...");
    (async () => {
      response = await PostFollowModel(uuid, action);
      //console.log("PostFollowModel response: "+JSON.stringify(response));

      let responseData = response?.data;
      let statusCode = response?.status;

      if (responseData === undefined) {
        return;
      }

      if (statusCode === 200) {
        if (responseData.code !== "1") {
        } else {
          const actionName = action !== "follow" ? "follow" : "unfollow";
          setAction(actionName);
          const icon =
            actionName === "follow" ? <StarIcon /> : <StarBorderIcon />;
          setStarIcon(icon);
        }
      } else {
      }

      return;
    })();
  }

  return (
    <div id="actions">
      <Button
        id="demo-customized-button"
        aria-controls={open ? "demo-customized-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        variant="contained"
        disableElevation
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
      >
        Actions
      </Button>
      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          "aria-labelledby": "demo-customized-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem
          onClick={() => navigate("/bulkDownload/" + uuid)}
          disableRipple
        >
          <BackupIcon />
          Bulk Download
        </MenuItem>

        <MenuItem
          className={`${isFollowed != null ? "block" : "hidden"} `}
          onClick={() => follow()}
          disableRipple
        >
          {starIcon}
          {action === "follow" ? "Follow" : "Unfollow"}
        </MenuItem>
      </StyledMenu>
    </div>
  );
}
